module.exports = __webpack_public_path__ + "img/map.f639e74a.png";